var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-scrollable",
              staticStyle: { "max-width": "96%" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "modal-content",
                  staticStyle: { height: "calc(100vh - 5px)" },
                },
                [
                  _c("div", { staticClass: "modal-header" }, [
                    _c("h5", { staticClass: "modal-title" }, [
                      _vm._v(_vm._s(_vm.title)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button" },
                        on: { click: _vm.close },
                      },
                      [_vm._v("×")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                ]
              ),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "modal-body", staticStyle: { height: "100%" } },
      [
        _c("div", {
          staticStyle: { height: "100%" },
          attrs: { id: "FullScreenChart" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }